<template>
  <v-app v-scroll="onScroll">
    <v-app-bar
      app
      color="white"
      v-if="isLogin"
      fixed
      :height="$vuetify.breakpoint.xs ? 80 : 120"
    >
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        class="nav-drawer-icon amber--text text--darken-4 d-flex d-sm-none"
      ></v-app-bar-nav-icon>

      <div class="copy-app-info-width">
        <router-link to="/">
          <img src="https://eip.pec.com.tw/images/UPEC_logo.png" class="logo" />
        </router-link>
      </div>
      <v-spacer></v-spacer>
      <router-link to="/" class="text-decoration-none">
        <div
          class="text-h3 amber--text text--darken-4 font-weight-bold text-center mx-1"
        >
          行動入口網
        </div>
      </router-link>
      <v-spacer></v-spacer>
      <div
        class="app-info d-none d-sm-flex flex-column align-end"
        ref="app-info"
      >
        <div class="text-h6 font-weight-regular" style="white-space: nowrap">
          您好，<span class="red--text text--darken-3">{{ userId }}</span> |
          <span class="cursor" @click="logout()">登出</span> |
          <router-link
            class="text-decoration-none"
            to="/"
            style="color: rgba(0, 0, 0, 0.87) !important"
            >回首頁</router-link
          >
        </div>
        <div class="d-flex justify-end align-center">
          <v-btn
            outlined
            color="red darken-3"
            @click="drawer = true"
            class="mr-2"
          >
            <v-icon small>fa-solid fa-bars</v-icon>選單
          </v-btn>
          <v-badge
            class="pc-badge-dot"
            color="red darken-3"
            dot
            :value="unreadCount > 0"
            offset-x="6"
            offset-y="6"
          >
            <v-btn outlined color="red darken-3" to="/notification">
              <v-icon small>fa-regular fa-bell</v-icon>
              推播
            </v-btn>
          </v-badge>
          <v-btn outlined color="red darken-3" to="/at-message" class="ml-2">
            <v-icon small>$eip_message</v-icon>留言
          </v-btn>
          <v-btn
            fab
            outlined
            rounded
            color="red darken-3"
            small
            class="ml-2"
            to="/chat"
          >
            <v-icon dense>fa-solid fa-person-circle-question</v-icon>
          </v-btn>
        </div>
      </div>
      <div
        class="app-info-mobile d-flex d-sm-none"
        @click="$router.push('/notification')"
      >
        <v-badge
          color="red darken-3"
          dot
          :value="unreadCount > 0"
          offset-x="5"
          offset-y="5"
        >
          <v-icon color="red darken-3">fa-regular fa-bell</v-icon>
        </v-badge>
      </div>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" fixed temporary touchless width="300">
      <div
        class="amber darken-1 pa-4 d-flex justify-space-between align-center text-h6"
      >
        <template>
          <span>您好，{{ userId }}</span>
          <v-btn
            depressed
            small
            color="white"
            class="amber--text text--darken-3"
            @click="logout()"
            >登出</v-btn
          >
        </template>
      </div>
      <!-- <v-list>
        <v-list-item
          v-for="(item, index) in filterNavDrawerLists"
          :key="index"
          link
          @click="$router.push(item.path)"
        >
          <v-list-item-content
            class="grey--text text--darken-1 font-weight-bold"
            :style="{
              'border-bottom': '1px solid #757575',
            }"
          >
            <v-list-item-title class="text-h6">
              <v-icon dense v-text="item.icon"></v-icon>

              {{ item.title }}</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list> -->
      <v-list class="mb-6">
        <template v-for="item in navDrawerListsNew">
          <v-list-item
            v-if="!item.children"
            :key="item.id"
            :prepend-icon="item.icon"
            class="drawer-list-color"
            @click.stop.prevent="clickNavDrawerLists(item)"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="item.name"></v-list-item-title>
          </v-list-item>
          <v-list-group
            v-else
            :key="item.id"
            :value="false"
            :prepend-icon="item.icon"
            no-action
          >
            <template v-slot:activator>
              <v-list-item-content
                @click.stop.prevent="clickNavDrawerLists(item)"
              >
                <v-list-item-title
                  class="drawer-list-color"
                  v-text="item.name"
                ></v-list-item-title>
              </v-list-item-content>
            </template>

            <template v-for="subItem in item.children">
              <v-list-item
                v-if="!subItem.children"
                :key="subItem.id"
                @click.stop.prevent="clickNavDrawerLists(subItem)"
              >
                <v-list-item-title v-text="subItem.name"></v-list-item-title>
              </v-list-item>
              <v-list-group v-else :key="subItem.id" :value="false" sub-group>
                <template #activator>
                  <v-list-item-content
                    @click.stop.prevent="clickNavDrawerLists(subItem)"
                  >
                    <v-list-item-title class="drawer-list-color">
                      {{ subItem.name }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="grandChild in subItem.children"
                  :key="grandChild.id"
                  @click.stop.prevent="clickNavDrawerLists(grandChild)"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="grandChild.name"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </template>
          </v-list-group>
        </template>
      </v-list>

      <div
        v-if="iosVerify"
        @click="delDialog = true"
        class="delAcc pa-3 white--text text-center amber darken-1 text-h6 cursor"
      >
        刪除帳號
      </div>
      <div v-else class="delAcc text-center" @click="changeEnvironment($event)">
        {{ version }} {{ windowLoc.includes("eip-dev") ? " (beta)" : "" }}
      </div>
    </v-navigation-drawer>

    <v-main
      :class="[
        $vuetify.breakpoint.xs && isLogin ? 'mb-15' : '',
        mainBgWhite ? 'main-bg-white' : '',
      ]"
    >
      <div id="pullToRefresh"></div>
      <router-view :key="$router.currentRoute.fullPath" id="main" />
      <div class="footer amber darken-4 d-none d-sm-flex"></div>
      <div class="pt-12 pb-6 justify-center d-none d-sm-flex">
        <div class="mr-5 mr-md-12 d-flex flex-column">
          <v-img
            src="https://eip.pec.com.tw/images/android-QRcode.png"
            :max-width="$vuetify.breakpoint.mdAndUp ? 80 : 60"
            :aspect-ratio="1"
            contain
          />
          <v-img
            src="/android-download.svg"
            contain
            :max-width="$vuetify.breakpoint.mdAndUp ? 80 : 60"
            class="mt-auto"
          />
        </div>
        <div class="d-flex">
          <v-img
            src="https://eip.pec.com.tw/images/mobile-logo.png"
            :width="$vuetify.breakpoint.mdAndUp ? 120 : 90"
            :aspect-ratio="512 / 474"
            contain
            class="flex-shrink-0 rounded-lg"
          />
          <div class="ml-4 ml-md-12">
            <div
              class="amber--text text--darken-4 font-weight-bold"
              :style="
                $vuetify.breakpoint.mdAndUp
                  ? { 'font-size': '40px' }
                  : { 'font-size': '32px' }
              "
            >
              下載行動入口網APP
            </div>
            <div
              class="font-weight-bold mt-3 mt-md-6"
              :style="
                $vuetify.breakpoint.mdAndUp
                  ? { 'font-size': '24px' }
                  : { 'font-size': '18px' }
              "
            >
              瀏覽體驗升級，訊息通知不漏接!
            </div>
          </div>
        </div>
        <div class="ml-5 ml-md-12 d-flex flex-column">
          <v-img
            src="https://eip.pec.com.tw/images/iOS-QRcode.png"
            :width="$vuetify.breakpoint.mdAndUp ? 80 : 60"
            contain
          />
          <v-img
            src="/iOS-download.svg"
            contain
            :max-width="$vuetify.breakpoint.mdAndUp ? 80 : 60"
            class="mt-auto"
          />
        </div>
      </div>
    </v-main>

    <v-btn
      v-if="showToTopIcon"
      class="mb-2 float-button-group"
      color="primary"
      dark
      fab
      small
      @click.stop="$vuetify.goTo(0)"
    >
      <v-icon small>fa-solid fa-angles-up</v-icon>
    </v-btn>

    <global-snackbar></global-snackbar>
    <global-dialog></global-dialog>

    <template>
      <!-- v-model="bottomNavigationValue" -->
      <!-- hide-on-scroll -->
      <v-bottom-navigation
        v-if="isLogin"
        fixed
        grow
        class="d-flex d-sm-none"
        :input-value.sync="bottomNav"
      >
        <v-btn
          value="home"
          @click="changeBottomPage('/')"
          :color="bottomNavigationValue == 'home' ? '#e6e6e6' : ''"
        >
          <span class="mt-1">首頁</span>
          <v-icon
            :color="bottomNavigationValue == 'home' ? 'amber darken-4' : ''"
            >{{
              `fa-${
                bottomNavigationValue == "home" ? "solid" : "thin"
              } fa-house`
            }}</v-icon
          >
        </v-btn>
        <v-btn
          value="leave"
          @click="changeBottomPage('/leave')"
          :color="bottomNavigationValue == 'leave' ? '#e6e6e6' : ''"
        >
          <span class="mt-1">{{
            leaveNotAllow ? "考勤查詢" : "考勤/請假"
          }}</span>
          <v-icon
            :color="bottomNavigationValue == 'leave' ? 'amber darken-4' : ''"
            >{{
              `fa-${
                bottomNavigationValue == "leave" ? "solid" : "thin"
              } fa-calendar`
            }}</v-icon
          >
        </v-btn>
        <v-btn
          value="frequent"
          @click="changeBottomPage('/frequent')"
          :color="bottomNavigationValue == 'frequent' ? '#e6e6e6' : ''"
        >
          <span class="mt-1">常用功能</span>
          <v-icon
            :color="bottomNavigationValue == 'frequent' ? 'amber darken-4' : ''"
            >{{
              `fa-${
                bottomNavigationValue == "frequent" ? "solid" : "thin"
              } fa-folder-tree`
            }}</v-icon
          >
        </v-btn>
        <v-btn
          value="chat"
          @click="changeBottomPage('/chat')"
          :color="bottomNavigationValue == 'chat' ? '#e6e6e6' : ''"
        >
          <span class="mt-1">智能服務</span>
          <v-icon
            :color="bottomNavigationValue == 'chat' ? 'amber darken-4' : ''"
            >{{
              `fa-${
                bottomNavigationValue == "chat" ? "solid" : "thin"
              } fa-person-circle-question`
            }}</v-icon
          >
        </v-btn>
        <v-btn
          value="message"
          @click="changeBottomPage('/at-message')"
          :color="bottomNavigationValue == 'at-message' ? '#e6e6e6' : ''"
        >
          <span class="mt-1">@留言</span>
          <v-icon v-if="bottomNavigationValue == 'at-message'"
            >$eip_message_btn_active</v-icon
          >
          <v-icon v-else>$eip_message_btn</v-icon>
        </v-btn>
      </v-bottom-navigation>
    </template>

    <v-dialog v-model="delDialog" scrollable max-width="600" persistent>
      <v-card class="px-4">
        <v-card-text class="pa-7" style="position: relative">
          <div
            class="text-h4 cursor"
            style="position: absolute; right: 0px; top: 15px"
            variant="flat"
            @click="delDialog = false"
          >
            <i class="fa-solid fa-circle-xmark" style="color: #bdbdbd"></i>
          </div>
          <div>
            <div
              border="left"
              class="py-0 mb-3 d-flex justify-content-start align-center text-h5 pr-3"
              style="
                color: #c62828;
                font-weight: 700;
                background-color: inherit;
              "
              dense
              tile
              colored-border
              color="#c62828"
              elevation="0"
            >
              是否確認刪除帳號
            </div>
            <p class="text-h6 mb-6" style="color: #000">
              此動作無法復原，刪除帳號後您將立即被登出。
            </p>
            <div class="d-flex justify-center">
              <v-btn
                class="mx-2"
                color="grey"
                style="
                  border-radius: 11px;
                  width: 124px;
                  font-size: 20px;
                  height: 30px;
                "
                dark
                label
                @click="delDialog = false"
                >取消
              </v-btn>
              <v-btn
                class="mx-2"
                color="amber darken-4"
                style="
                  border-radius: 11px;
                  width: 124px;
                  font-size: 20px;
                  height: 30px;
                "
                dark
                label
                @click="
                  delDialog = false;
                  delAcc();
                "
                >確定
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { mapWritableState, mapStores, mapState, mapActions } from "pinia";
import { useAppStore } from "@/stores/appStore";
import GlobalDialog from "@/components/GlobalDialog.vue";
import GlobalSnackbar from "@/components/GlobalSnackbar.vue";
import { apiAxios } from "@/api";
import PullToRefresh from "pulltorefreshjs";
import { db } from "@/firebase";
import { collection, addDoc } from "firebase/firestore";

export default {
  name: "App",
  components: { GlobalDialog, GlobalSnackbar },
  created() {
    this.interfaceTime = [];
    this.interfaceTime.push(new Date());
    window.updateBadgeToWeb = this.updateBadgeToWeb;
    if (window.EipJSInterface && window.EipJSInterface.setUserId) {
      window.EipJSInterface.setUserId(this.userId || "");
    }
  },
  async mounted() {
    if (window.EipJSInterface && window.EipJSInterface.onLoadFinish) {
      window.EipJSInterface.onLoadFinish();
      this.interfaceTime.push(new Date());
    }

    try {
      if (this.isLogin) {
        if (!this.navDrawerListsNew.length) {
          this.getNewNavDrawerLists();
        }
        this.updateNotificationCount();
        this.getLeaveFlag().catch((error) => {
          this.$dialog.show(`取得請假權限時出現錯誤，${error}`);
        });

        if (this.$route.path == "/") {
          this.pullToRefresh();
        }
      }
      this.appStore.$onAction(({ name }) => {
        if (name === "logout") {
          this.$router.push("/login");
        }
      });
    } catch (error) {
      try {
        await addDoc(collection(db, "loadingErrorLogs"), {
          userId: this.userId,
          error: error,
          creationDate: new Date(),
          page: "App.vue",
        });
      } catch (error) {
        null;
      }
      window.location.reload();
    } finally {
      this.isLoading = false;
    }
  },
  data: () => ({
    scrollTop: 0,
    drawer: false,
    navDrawerLists: [
      {
        title: "常用功能設定",
        path: "/tree",
        icon: "fa-solid fa-square-check",
      },
      { title: "系統設定", path: "/setting", icon: "fa-solid fa-user-gear" },
      { title: "關於", path: "/about", icon: "fa-solid fa-file-shield" },
      { title: "裝置版本", path: "/device-state", icon: "fa-solid fa-wrench" },
    ],
    // navDrawerListsNew: [],
    delDialog: false,
    version: process.env.VUE_APP_VERSION,
    windowLoc: window.location.hostname,
    bottomNav: true,
    mainBgWhite: false,
  }),
  computed: {
    ...mapWritableState(useAppStore, [
      "isLogin",
      "unreadCount",
      "interfaceTime",
    ]),
    ...mapState(useAppStore, [
      "userId",
      "imgUrl",
      "iosVerify",
      "leaveNotAllow",
      "navDrawerListsNew",
    ]),
    ...mapStores(useAppStore),
    showToTopIcon() {
      return this.scrollTop > 400;
    },
    bottomNavigationValue: {
      get() {
        return this.$route.name;
      },
      set() {
        return this.$route.name;
      },
    },
    appInfoWidth() {
      return this.$refs["app-info"]?.clientWidth;
    },
    filterNavDrawerLists() {
      if (window.EipJSInterface) {
        return this.navDrawerLists;
      } else {
        return this.navDrawerLists.filter((e) => e.title !== "裝置版本");
      }
    },
  },
  watch: {
    "$route.path"() {
      // console.log(this.$router.currentRoute.path);
      if (this.$router.currentRoute.path !== "/login") {
        this.updateNotificationCount();
        // this.getLeaveFlag().catch((error) => {
        //   this.$dialog.show(`取得請假權限時出現錯誤，${error}`);
        // });
      }

      // should force bottom nav show when change route
      this.bottomNav = true;

      let routeArr = [
        "/",
        "/notification",
        "/sign",
        "/leave-query",
        "/leave-settings",
        "/leave-state",
        "/salary-income",
        "/yearend-bonus",
        "/performance-bonus",
        "/annual-income",
      ];
      if (routeArr.includes(this.$route.path)) {
        this.$nextTick(() => {
          this.pullToRefresh();
        });
      } else {
        PullToRefresh.destroyAll();
      }

      let bgwhiteRouteArr = [
        "/at-message",
        "/message-notify",
        "/message-record",
      ];
      if (bgwhiteRouteArr.includes(this.$route.path)) {
        this.mainBgWhite = true;
      } else {
        this.mainBgWhite = false;
      }
    },
  },
  methods: {
    ...mapActions(useAppStore, [
      "logout",
      "refreshAccessToken",
      "clearToken",
      "getNotificationLength",
      "getLeaveFlag",
      "setBadgeNumber",
      "getNewNavDrawerLists",
    ]),
    clickNavDrawerLists(item) {
      if (item.url.includes("http")) {
        if (item.url.includes(".pdf")) {
          if (
            window.EipJSInterface &&
            window.EipJSInterface.openPDFReaderInApp
          ) {
            window.EipJSInterface.openPDFReaderInApp(item.url);
          }
        } else {
          if (window.EipJSInterface && window.EipJSInterface.openInAppBrowser) {
            window.EipJSInterface.openInAppBrowser(item.url);
          } else {
            window.open(item.url);
          }
        }
      } else {
        this.$router.push(item.url).catch(() => null);
      }
    },
    updateBadgeToWeb() {
      // APP 從背景換至前景時，APP 觸發更新未讀數量
      if (this.isLogin) {
        this.getNotificationLength();
      }
    },
    onScroll(e) {
      this.scrollTop = e.target.documentElement.scrollTop;
    },
    inAppBrowser(src) {
      if (window.EipJSInterface && window.EipJSInterface.openInAppBrowser) {
        window.EipJSInterface.openInAppBrowser(src);
      } else {
        window.open(src);
      }
    },
    changeBottomPage(router) {
      let samePath = false;
      if (this.$route.fullPath == router) {
        samePath = true;
      }
      if (!samePath) {
        this.$router.push(router);
      }
    },
    delAcc() {
      return apiAxios({
        method: "post",
        url: process.env.VUE_APP_ROOT_API + "/Acc/Remove",
        data: this.userId,
      })
        .then((res) => {
          if (res.status == 1) {
            // clear token & logout
            this.clearToken();
            this.logout();
          }
        })
        .catch(() => {
          this.drawer = false;
          this.$snackbar.add("刪除失敗");
        });
    },
    async updateNotificationCount() {
      //更新訊息已讀狀態
      const urlParams = new URLSearchParams(window.location.search);
      const messageId = urlParams.get("push_id");
      const userId = urlParams.get("user_no");

      // try {
      if (messageId) {
        await apiAxios({
          method: "post",
          url:
            process.env.VUE_APP_ROOT_API +
            "/NotificationCenter/setNotificationReadStatus",
          data: messageId
            ? {
                id: messageId,
                user_id: userId,
              }
            : {},
        })
          .then((res) => {
            this.unreadCount =
              res.result.import_unread_count + res.result.personal_unread_count;
            this.setBadgeNumber(this.unreadCount);
          })
          .catch((error) => {
            this.$dialog.show(`更新推播未讀數量時發生錯誤，${error}`);
          });
      } else {
        await apiAxios({
          method: "post",
          url:
            process.env.VUE_APP_ROOT_API +
            "/NotificationCenter/GetUserUnreadCount",
          data: {},
        })
          .then((res) => {
            this.unreadCount =
              res.result.import_unread_count + res.result.personal_unread_count;
            this.setBadgeNumber(this.unreadCount);
          })
          .catch((error) => {
            this.$dialog.show(`取得推播未讀數量時發生錯誤，${error}`);
          });
      }
    },
    pullToRefresh() {
      PullToRefresh.init({
        mainElement: "#pullToRefresh",
        onRefresh() {
          window.location.reload();
        },
        instructionsPullToRefresh: "下拉重整頁面",
        instructionsReleaseToRefresh: "下拉重整頁面",
        instructionsRefreshing: "重整中",
        distReload: 65,
        refreshTimeout: 250,
      });
    },
    changeEnvironment() {
      if (window.EipJSInterface && window.EipJSInterface.changeEnvironment) {
        window.EipJSInterface.changeEnvironment();
      }
    },
  },
};
</script>
<style>
body #app.v-application .v-application--wrap *:not(.v-icon):not(i) {
  font-family: "Noto Sans TC" !important;
  font-optical-sizing: auto;
  /* font-weight: 200; */
  font-style: normal;
}
.float-button-group {
  position: fixed;
  bottom: 60px;
  right: 12px;
  z-index: 4;
}
/* .v-application--wrap {
  min-height: 100dvh !important;
  min-height: -webkit-fill-available;
} */
/* #app {
  font-family: "Noto Sans TC" !important;
} */
html {
  font-size: 16px;
}
.v-main {
  margin: 0 auto;
  width: 100%;
  height: 100%;
}
.v-main__wrap {
  height: 100%;
  background-color: #f5f5f5;
}
.main-bg-white .v-main__wrap {
  background-color: #fff !important;
}
.v-badge-outline .v-badge__badge {
  background-color: #fff !important;
  color: var(--v-primary-base);
  border: 3px solid var(--v-primary-base) !important;
  border-radius: 50%;
  padding: 0px;
  margin: 0px;
  line-height: 1.33;
  /* font-family: "Microsoft JhengHei"; */
  font-weight: 900;
}
.delAcc {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #ccc;
  background-color: #fff;
}
.theme--light.v-bottom-navigation {
  color: rgba(0, 0, 0, 0.54);
}
.footer {
  height: 10px;
  margin-top: 40px;
}
/* .container {
  height: calc(100% - 10px);
} */
.app-info-mobile {
  cursor: pointer;
}
.v-app-bar-title__content {
  display: flex;
}
.v-application a {
  color: #c62828 !important;
}
.v-application li:first-child a {
  padding-left: 16px;
  border-left: 4px solid currentColor;
}
.v-application .v-breadcrumbs__divider {
  color: #c62828 !important;
  /* padding: 0 8px !important; */
}
.cursor {
  cursor: pointer;
}
.home-width {
  max-width: 1240px;
}
.mobile-card-setting {
  min-height: 80vh;
}
.leave-state-mobile {
  min-height: 67vh;
}
.copy-app-info-width {
  width: 250px;
}
.v-menu__content .v-list--dense .v-list-item .v-list-item__title {
  font-size: 1rem !important;
}
.pc-badge-dot.v-badge--dot .v-badge__badge {
  height: 10px !important;
  width: 10px !important;
}
.v-navigation-drawer--temporary {
  z-index: 20;
}
.ptr--icon,
.ptr--text {
  color: #ffb300 !important;
  font-size: 1.5rem;
}
.v-item-group.v-bottom-navigation .v-btn {
  min-width: 60px !important;
}
.font-size-14 {
  font-size: 14px !important;
}
.font-size-16 {
  font-size: 16px !important;
}
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0 !important;
}
.theme--light.v-list-item:hover::before {
  opacity: 0 !important;
}
.v-list .v-list-group.v-list-group--active,
.drawer-list-color,
.drawer-list-color .v-list-item__icon .v-icon,
.v-list-group__header__prepend-icon .v-icon {
  color: rgba(0, 0, 0, 0.67) !important;
}
.theme--light.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  color: rgba(0, 0, 0, 0.67);
}
.v-list-item--active,
.drawer-list-color {
  font-weight: 600;
}
.v-app-bar.v-app-bar--fixed {
  z-index: 12;
}
@media (max-width: 992px) {
  /* html {
    font-size: 14px;
  } */
  .logo {
    width: 90px;
  }
  .copy-app-info-width {
    width: 214px;
  }
}
@media (max-width: 442px) {
  /* html {
    font-size: 12px;
  } */
  .logo {
    width: 54px;
  }
  .v-application .text-h3 {
    font-size: 2.5rem !important;
  }
  #app .mobile-card-setting {
    box-shadow: unset !important;
    background-color: transparent !important;
  }
}
@media (max-width: 375px) {
  .v-main__wrap {
    background-color: #fff;
  }
  .leave-state-mobile {
    margin: -12px;
    box-shadow: unset !important;
    margin-top: 0 !important;
  }
}
@media (max-width: 600px) {
  #app .mobile-card-setting {
    box-shadow: unset !important;
    background-color: transparent !important;
  }
  .copy-app-info-width {
    width: auto;
  }
  .leave-state-mobile {
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
      0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
    background-color: #fff;
    padding: 12px;
    border-radius: 4px;
    margin-top: 30px;
  }
}
</style>
